import { useCallback, useMemo, useState } from "react";

const useModal = () => {
	const [isOpen, setIsOpen] = useState(false);

	const openModal = useCallback(() => {
		setIsOpen(true)
	}, []);
	const closeModal = useCallback(() => {
		setIsOpen(false)
	}, []);

	return useMemo(() => ({
		isOpen,
		openModal,
		closeModal,
	}), [isOpen, openModal, closeModal])
}

export default useModal;